import type { SectorAnalysisPayload } from '@/services/api';
import { SectorAnalogAnalysisPanel } from './SectorAnalogAnalysisPanel';

export function SectorAnalysisReport({ analysis }: { analysis: SectorAnalysisPayload }) {
  return (
    <article className="sector-analysis-report">
      <SectorAnalogAnalysisPanel analysis={analysis} />
    </article>
  );
}
